// set plugin names by pageTypes for ajax requests
export const AjaxPageTypes = {
	Configurator: {
		typeNum: 3500,
		pluginName: 'tx_iggrafinfiltration_configurator'
	},
	Administration: {
		typeNum: 3510,
		pluginName: 'tx_iggrafinfiltration_administration'
	}
};